import { metrics } from '@seek/metrics-js';
import { useTranslations } from '@vocab/react';
import { TextLink } from 'braid-design-system';

import Subscription from '../common/subscription';
import { useRoutes } from '../routes';
import { trackUnsubscribeFailedPageLoad } from '../tracking/tealium';

import translations from './.vocab';
import { UnsubscribeIcon } from './svg/unsubscribe-icon';

export const UnsubscribeUnsuccessful = () => {
  const { preferenceCentrePath } = useRoutes();
  const { t } = useTranslations(translations);

  trackUnsubscribeFailedPageLoad();
  metrics.count('unsubscribe-unsuccessful-page-rendered');

  return (
    <Subscription
      title={t('unsubscribe-unsuccessful-title')}
      cardTitle={t('unsubscribe-unsuccessful-card-title')}
      body={
        <>
          {t('unsubscribe-unsuccessful-body', {
            link: (children) => (
              <TextLink data-testid="manage-link" href={preferenceCentrePath}>
                {children}
              </TextLink>
            ),
          })}
        </>
      }
      svg={<UnsubscribeIcon />}
    />
  );
};
